module.exports = __webpack_public_path__ + "static/img/5.1eacac1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/99/zh/5.png
// module id = idP6
// module chunks = 0